import { useGetHttp } from "../../http.hook";
import type { IFavoriteSocial } from "./get-all-favorites.admin.http";


interface IResponse {
  favouriteSocials: Array<IFavoriteSocial>;
}

export function useFavoriteSocialSearchAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/search",
  });
}